import { SensorExtraction } from '../models/sensorExtraction'

export interface SensorExtractionStateType {
  sensorExtractions: SensorExtraction[]
  sensorExtraction: SensorExtraction | null
}

const SensorExtractionState: () => SensorExtractionStateType = () => ({
  sensorExtractions: [],
  sensorExtraction: null,
})

export default SensorExtractionState
